import h from 'hyperscript';
import closeIcon from '@disy/cadenza-icons/close.svg';

import { Dialog } from 'ui/dialog/dialog';

import { icon } from 'cadenza/utils/icon/icon';
import { commonI18n as i18n } from 'cadenza/utils/i18n/i18n';

import './info-dialog.css';

import { legacySetupScrollShadow } from 'cadenza/utils/scroll-shadow/scroll-shadow';

import 'ui/compact-header/compact-header.css';

const name = 'd-info-dialog';

/**
 * A dialog _only_ to display some static (info) content.
 *
 * @deprecated - Use {@link Modal} instead.
 */
export class InfoDialog extends Dialog {

  static get elementName () {
    return name;
  }

  constructor (headerIcon, title, infoContent) {
    super();
    this.dialog.classList.add(name);
    this._header = createHeader(headerIcon, title);
    this.dialog.append(this._header);
    this.content = infoContent;
  }

  get dialogTitle () {
    return this.dialog.querySelector(`.${name}--title`).textContent;
  }

  set dialogTitle (newTitle) {
    const titleElement = this.dialog.querySelector(`.${name}--title`);
    titleElement.textContent = newTitle;
  }

  set content (el) {
    if (this.content) {
      this.content.remove();
    }
    if (el) {
      if (typeof el === 'string' || el instanceof DocumentFragment) {
        el = h('div', el);
      }
      el.classList.add(`${name}--content`);
      this.dialog.appendChild(el);
      legacySetupScrollShadow(el, this._header);
    }
  }

  get content () {
    return this.dialog.querySelector(`.${name}--content`);
  }

  show () {
    this.dialog.classList.remove('closed');
    super.show();
  }

  showModal () {
    this.dialog.classList.add('closed');
    super.showModal();
    this.dialog.classList.remove('closed');
  }

  close () {
    if (!this.dialog.classList.contains('closed') && this.dialog.open) {
      this.dialog.classList.add('closed');
      setTimeout(() => super.close(), 400); // duration of the CSS transition
    }
  }

}

customElements.define(name, InfoDialog);

function createHeader (headerIcon, title) {
  return h('header.d-compact-header', [
    headerIcon && icon(headerIcon),
    h(`span.${name}--title.d-compact-header--title`, title),
    h('button.button.button-icon.button-borderless.button-s.cancel', {
      'type': 'button',
      'title': i18n('close')
    }, icon(closeIcon))
  ]);
}
